
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import DashboardSummary from '@/components/DashboardSummary';
import AppLayout from '@/components/layout/AppLayout';

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-background">
        <div className="text-center space-y-6">
          <h1 className="text-4xl font-bold mb-4 text-brand-primary">Welcome to Donation Platform</h1>
          <p className="text-xl text-brand-secondary mb-8">Please sign in to continue</p>
          <Button onClick={() => navigate('/auth')} size="lg" className="bg-brand-primary hover:bg-brand-secondary">
            Sign In / Register
          </Button>
        </div>
      </div>
    );
  }

  return (
    <AppLayout>
      <DashboardSummary />
    </AppLayout>
  );
};

export default Index;
